import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { ProfileMenu } from "../ProfileMenu/ProfileMenu";
import "./ProfileSecurity.css";
import { useAppDispatch } from "../../../store/hooks/store.hooks";
import { useNavigate } from "react-router-dom";
import {
  resetPassword,
  validatePassword,
} from "../../../store/models/auth/auth.thunk";
import { Form, Formik } from "formik";
import { RequestPasswordAuthSchema } from "../../../utils/formValidations";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { ProfileInput } from "../../input/input";

const ProfileSecurity = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 599.98 });
  const [loading, setLoading] = useState(false);
  const [infoMessage, setInfoMessage] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleSubmit = async (
    data: any,
    { setSubmitting, setFieldError, setStatus }: any
  ) => {
    const { password, currentPassword } = data;
    setLoading(true);

    if (currentPassword) {
      const validateResponse = await dispatch(
        validatePassword({
          password: currentPassword,
        })
      );
      //@ts-ignore
      if (validateResponse?.payload?.message === "Password not valid") {
        setFieldError(
          "currentPassword",
          t("main.profile.security.password_invalid")
        );
        setSubmitting(false);
        setLoading(false);
        return;
      }
    }

    const resetResponse = await dispatch(
      resetPassword({
        password: password,
        token: localStorage.getItem("game-token") || "",
      })
    );

    // debugger;
    //@ts-ignore
    if (resetResponse?.payload?.message === "Authentification failed") {
      setFieldError("password", t("main.profile.security.token_invalid"));
      setFieldError("confirmPassword", " ");
      setSubmitting(false);
      setLoading(false);
      return;
    }
    //@ts-ignore
    if (resetResponse?.payload?.message === "Authorization error") {
      setFieldError("password", t("main.profile.security.token_invalid"));
      setFieldError("confirmPassword", " ");
      setSubmitting(false);
      setLoading(false);
      return;
    }

    //@ts-ignore
    if (resetResponse?.payload?.message === "Cannot set password to old one") {
      setFieldError("password", t("main.profile.security.same_password"));
      setFieldError("confirmPassword", " ");
      setSubmitting(false);
      setLoading(false);
      return;
    }

    // debugger;
    setInfoMessage(true);
    setLoading(false);
  };
  return (
    <Box className="profile-security">
      {!isMobile && (
        <ProfileMenu
          items={[
            {
              text: t("main.profile.menu.security"),
              to: "/profile/security",
            },
          ]}
        />
      )}
      <Box className="profile-security__container">
        <Typography className="profile-security__main-label">
          {t("main.profile.security.change_password")}
        </Typography>
        <Formik
          onSubmit={handleSubmit}
          initialValues={{
            currentPassword: "",
            password: "",
            confirmPassword: "",
          }}
          validationSchema={RequestPasswordAuthSchema}
        >
          {({ errors, touched, handleChange, handleBlur, values }) => (
            <Form className="profile-security__form">
              <Box
                className="primary-text-color"
                style={{ position: "relative" }}
              >
                <ProfileInput
                  error={errors.currentPassword}
                  touched={touched.currentPassword}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  value={values.currentPassword}
                  name="currentPassword"
                  label={t("main.profile.security.old")}
                  withoutPlaceholder
                  type="password"
                />
              </Box>

              <Box style={{ position: "relative" }}>
                <ProfileInput
                  error={errors.password}
                  touched={touched.password}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  value={values.password}
                  name="password"
                  label={t("main.profile.security.new")}
                  withoutPlaceholder
                  type="password"
                />
              </Box>
              <Box style={{ position: "relative" }}>
                <ProfileInput
                  error={errors.confirmPassword}
                  touched={touched.confirmPassword}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  value={values.confirmPassword}
                  name="confirmPassword"
                  label={t("main.profile.security.repeat")}
                  withoutPlaceholder
                  type="password"
                />
              </Box>
              <Box className="profile-security__button-container">
                <Button
                  style={{ width: "auto" }}
                  disabled={loading}
                  className={"Button" + ` Button-secondary`}
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  {loading ? (
                    <CircularProgress
                      style={{
                        height: "25px",
                        width: "25px",
                        color: "rgb(223, 0, 67)",
                      }}
                    />
                  ) : (
                    t("main.profile.security.button")
                  )}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
      <Dialog
        open={infoMessage}
        onClose={() => setInfoMessage(false)}
        className="game-dialog bonus-dialog"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          top: { xs: "56px", sm: "86px" },
          ".MuiBackdrop-root": {
            top: { xs: "56px", sm: "86px" },
          },
        }}
        PaperProps={{
          sx: {
            maxWidth: "500px",
            backgroundImage: "none",
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {t("main.profile.security.success")}
        </DialogTitle>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <Button
            className={"Button" + ` Button-secondary`}
            onClick={() => {
              setInfoMessage(false);
              navigate("/");
            }}
            // fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {t("main.profile.security.success_button")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ProfileSecurity;
